module.exports = __webpack_public_path__ + "static/media/arlene26.d418501a.JPG";